/** Mirrors Levitate.Models.WebsiteProviders. Read-only: the platform observes this, clients never set it. */
export enum WebsiteProvider {
	Duda = 'Duda',
	Levitate = 'Levitate',
}

export interface WebsiteProviderDisplay {
	label: string;
	// A subset of the Pill palette (keyof ThemeColors['pill']).
	color: 'gray' | 'teal';
}

export const WEBSITE_PROVIDER_DISPLAY: Record<WebsiteProvider, WebsiteProviderDisplay> = {
	[WebsiteProvider.Duda]: { label: 'Duda', color: 'gray' },
	[WebsiteProvider.Levitate]: { label: 'Levitate-Built', color: 'teal' },
};

export interface WebsiteProviderSource {
	provider?: string;
	dudaSiteId?: string;
}

/**
 * Undefined for an absent or unrecognized value, which callers must show as Unknown -- never as Duda,
 * since assuming Duda is what sends support to an editor holding no site.
 */
export function resolveWebsiteProvider(websites: WebsiteProviderSource | undefined): WebsiteProvider | undefined {
	const stored = websites?.provider?.trim().toLowerCase();
	if (!stored) {
		return undefined;
	}

	return Object.values(WebsiteProvider).find(provider => provider.toLowerCase() === stored);
}

export const UNKNOWN_WEBSITE_PROVIDER_DISPLAY: WebsiteProviderDisplay = { label: 'Unknown', color: 'gray' };

/** Display for the account's provider, reading as Unknown when it resolves to nothing. */
export const getWebsiteProviderDisplay = (websites: WebsiteProviderSource | undefined): WebsiteProviderDisplay => {
	const provider = resolveWebsiteProvider(websites);
	return provider ? WEBSITE_PROVIDER_DISPLAY[provider] : UNKNOWN_WEBSITE_PROVIDER_DISPLAY;
};

export const isLevitateBuiltWebsite = (websites: WebsiteProviderSource | undefined): boolean =>
	resolveWebsiteProvider(websites) === WebsiteProvider.Levitate;
